import { render, staticRenderFns } from "./ModalBase.vue?vue&type=template&id=ddb207fe&scoped=true&lang=pug&"
import script from "./ModalBase.vue?vue&type=script&lang=ts&"
export * from "./ModalBase.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBase.vue?vue&type=style&index=0&id=ddb207fe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb207fe",
  null
  
)

export default component.exports